export const REQUEST_BATCH_DETAIL = 'REQUEST_BATCH_DETAIL';
export const RECEIVE_BATCH_DETAIL = 'RECEIVE_BATCH_DETAIL';
